export enum Environment {
  Development = 'development', //a.k.a. Stage, a.k.a. Localhost
  Production = 'production',
  UAT = 'UAT',
}
